import { Range } from '../models';

export const DEFAULT_LOAD_RANGE: Range = { min: 0, max: 1, step: 1 };
